import coprez from "../data/execs/copres.jpg";
import advisory from "../data/execs/advisory.jpg";
import comms from "../data/execs/comms.jpg";
import events from "../data/execs/events.png";
import external from "../data/execs/external.jpg";
import internal from "../data/execs/internal-2.jpg";
import finance from "../data/execs/finance-2.jpg";
import fyr from "../data/execs/fyr.jpg";



const execs = [
    {src: coprez, description: "Co-presidents"},
    {src: events, description: "Event Coord"},
    {src: external, description: "Externals"},
    {src: finance, description: "Finance"},
    {src: fyr, description: "First Year Rep"},
    {src: internal, description: "Internal"},
    {src: comms, description: "Comms"},
    {src: advisory, description: "Senior Advisor"}
];

export default execs;